import React from 'react';

const ManageCategoriesAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/manage-categories',
			exact:true,
			component: React.lazy(() => import('./categories/Categories'))
		},
		{
			path: '/store',
			exact:true,
			component: React.lazy(() => import('./categories/Categories'))
		},
		{
			path: '/store-report',
			exact:true,
			component: React.lazy(() => import('./categories/StoreReport'))
		},
		{
			path: '/upload-invoice',
			exact:true,
			component: React.lazy(() => import('./categories/UploadInvoice'))
		},
		{
			path: '/products',
			exact:true,
			component: React.lazy(() => import('./categories/Producto'))
		}
		// {
		// 	path: '/add-tastes/:tastesId',
		// 	component: React.lazy(() => import('./AddTastes/AddTastes'))
		// }

	]
};

export default ManageCategoriesAppConfig;
